define([
	"dojo/_base/declare",
	"csi/table/matrix/Path"
], function(declare, PathMatrix) {

	return declare(PathMatrix, {
		/**
		 * @override
		 * Adding null at beginning of nodes array will create an empty cell so size and colorway matrices align
		 */
		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			if (!ctx.isStaticOutput()) {
				nodes.unshift(null);
			}

			return nodes;
		}
	});
});